// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__FfCSp","loader__content":"Loader_loader__content__B09XK","load8":"Loader_load8__VEmJm"};